import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { UserRole, UserService } from 'app/_services/user.service';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, OnDestroy {
    private _subrelease: Subscription = new Subscription();

    private _isAuthenticated: boolean;
    private _currentRole: UserRole;

    constructor(private router: Router, private userService: UserService) {
        const self = this;
        self._isAuthenticated = false; // Default to not authenticated.

        self._subrelease.add(
            self.userService.UserSubject.subscribe((user) => {
                self._isAuthenticated = user && user.authToken != null && user.authToken !== '';
                self._currentRole = user && user.CurrentRole;
            })
        );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // At a minimum, only allow access if we have a valid authtoken stored for the current user.
        const isAuth = this._isAuthenticated;

        const user = this.userService.UserValue;
        let matchingRole = false;

        // If isAuth fails, then the user is not logged in, so redirect them to login page with return url
        if (!isAuth) {
            this.router.navigate([RoutePath.Login], { queryParams: { returnUrl: state.url } });
            return false;
        }

        // Check if route is restricted by role
        if (route.data != null && route.data.roles != null && route.data.roles.length > 0) {
            if (this._currentRole == null) {
                return false;
            }

            const authRoles: string[] = route.data.roles;

            for (let i = 0; i < user.roles.length; i++) {
                const index = authRoles.indexOf(user.roles[i].roleName);
                if (index != -1) {
                    matchingRole = true;
                    break;
                }
            }
        }

        // If the user has no matching roles, then the user is not authroized to view that route,
        // so redirect them to the Unauthorized paged.
        if (!matchingRole) {
            this.router.navigate([RoutePath.PageNotAuthorized]);
            return false;
        }

        return isAuth;
    }

    ngOnDestroy() {
        this._subrelease.unsubscribe();
    }
}
